// GPC 배송비 분담금 단가 관리 (gpc-rate) — 화면 엔트리(개발자 소유, 문서 51 컴포넌트 모드).
//  겉(UI)은 컨덕터 생성본 `./handoff/page.generated`(GeneratedPageView)이 그리고, 이 파일은 배선(Wiring)만 넘긴다.
//  재핸드오프는 생성본만 통째로 덮는다 — 이 파일과 `./wiring.ts` 는 남는다.
//  2026-09-21 전환: 지난 핸드오프(#778)의 엔트리는 생성본 자체(엔트리 모드)였고 dev 배선이 없던 화면이라, 뷰를 부르는 얇은 엔트리로 바꿨다.
//  데이터·API 배선은 `./wiring.ts` 가 갖는다.
import GeneratedPageView from './handoff/page.generated'
import { wiring } from './wiring'
import { usePermissionSlot } from '@/hooks/useMenuPermission'

// wiring.ts 가 `./index` 에서 계약 타입을 가져온다(컨덕터 골격 그대로) — 정본은 생성본이 내는 Wiring 이다.
export type { ActionCtx, Option, Row, ValidateView, Wiring } from './handoff/page.generated'

export default function GpcRatePage() {
  return <GeneratedPageView wiring={{ ...wiring, permission: usePermissionSlot('gl16') }} />
}
